/**
 * Cart Bundle Tiers — logique dynamique du module cart-bundle-tiers.liquid
 * Chargée au niveau du thème (layout/theme.liquid) pour survivre aux re-renders
 * du cart drawer (Dawn fait innerHTML = ... qui n'exécute pas les scripts inline).
 */
(function(){
  if (window.__cartBundleTiersInstalled) return;
  window.__cartBundleTiersInstalled = true;

  var currency = 'EUR';
  if (window.Shopify && window.Shopify.currency) {
    currency = window.Shopify.currency.active || 'EUR';
  }

  function formatMoney(cents){
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency', currency: currency
      }).format(cents / 100);
    } catch(e) {
      return (cents / 100).toFixed(2) + ' €';
    }
  }

  function computeMaxPct(slots, totalQty){
    var maxPct = 0;
    slots.forEach(function(s){
      var th = parseInt(s.dataset.threshold, 10) || 0;
      if (totalQty >= th) {
        var m = (s.dataset.reward || '').match(/(\d+)\s*%/);
        if (m) { var p = parseInt(m[1], 10); if (p > maxPct) maxPct = p; }
      }
    });
    return maxPct;
  }

  function update(state){
    var root = document.querySelector('[data-cart-bundle-tiers]');
    if (!root) return;

    var slots = root.querySelectorAll('[data-cbt-slot]');
    var messageEl = root.querySelector('[data-cbt-message]');
    var shippingWrap = root.querySelector('[data-cbt-shipping]');
    var shippingFill = root.querySelector('[data-cbt-shipping-fill]');
    var shippingText = root.querySelector('[data-cbt-shipping-text]');

    /* Utilise state (venant de /cart.js) si fourni, sinon lit les data-attrs Liquid */
    var totalCents, totalQty, cartImages, shippingThreshold, shippingTextTpl;
    if (state) {
      totalCents = state.totalCents;
      totalQty = state.totalQty;
      cartImages = state.cartImages;
    } else {
      totalCents = parseInt(root.dataset.totalCents, 10) || 0;
      totalQty = parseInt(root.dataset.totalQty, 10) || 0;
      cartImages = (root.dataset.cartImages || '').split('|').filter(Boolean);
    }
    shippingThreshold = parseInt(root.dataset.shippingThreshold, 10) || 0;
    /* Le template texte est stocké sur le p au premier render */
    if (shippingText && !shippingText.dataset.tpl) {
      shippingText.dataset.tpl = shippingText.textContent;
    }
    shippingTextTpl = shippingText ? shippingText.dataset.tpl : '';

    var maxPct = computeMaxPct(slots, totalQty);
    var discountedTotal = maxPct > 0 ? Math.round(totalCents * (100 - maxPct) / 100) : totalCents;

    /* Slots */
    var nextTier = null;
    slots.forEach(function(slot, idx){
      var th = parseInt(slot.dataset.threshold, 10) || 0;
      var reached = totalQty >= th;
      slot.classList.toggle('cbt__slot--reached', reached);
      var imgWrap = slot.querySelector('[data-cbt-slot-img]');
      var imgUrl = cartImages[idx];
      if (imgWrap && imgUrl) {
        var existing = imgWrap.querySelector('img');
        if (!existing || existing.getAttribute('src') !== imgUrl) {
          imgWrap.innerHTML = '<img src="' + imgUrl + '" alt="">';
        }
        slot.classList.add('cbt__slot--has-img');
      } else if (imgWrap) {
        imgWrap.innerHTML = '';
        slot.classList.remove('cbt__slot--has-img');
      }
      if (!reached && !nextTier) {
        nextTier = { label: slot.dataset.reward, threshold: th, remaining: th - totalQty };
      }
    });

    /* Message */
    if (messageEl) {
      if (totalQty === 0) {
        messageEl.innerHTML = messageEl.dataset.defaultMessage || messageEl.textContent;
      } else if (nextTier) {
        messageEl.innerHTML = 'Plus que <b>' + nextTier.remaining + ' article' +
          (nextTier.remaining > 1 ? 's' : '') + '</b> pour <b>' + nextTier.label + '</b>';
      } else {
        messageEl.innerHTML = '<b>Toutes les récompenses débloquées ! 🎉</b>';
      }
    }

    /* Progress livraison */
    if (shippingWrap && shippingThreshold > 0) {
      var pct = Math.min(100, Math.round(discountedTotal / shippingThreshold * 100));
      if (shippingFill) {
        shippingFill.style.setProperty('--cbt-ship-pct', pct + '%');
        shippingFill.style.setProperty('width', pct + '%', 'important');
      }
      var remaining = Math.max(0, shippingThreshold - discountedTotal);
      if (shippingText) {
        if (remaining === 0) {
          shippingWrap.classList.add('cbt__shipping--reached');
          shippingText.innerHTML = '✓ Livraison offerte débloquée';
        } else {
          shippingWrap.classList.remove('cbt__shipping--reached');
          if (discountedTotal === 0) {
            shippingText.innerHTML = shippingTextTpl;
          } else {
            var remainingE = Math.ceil(remaining / 100);
            shippingText.innerHTML = 'Encore <b>' + remainingE + '€</b> pour livraison offerte';
          }
        }
      }
    }
  }

  /* Refetch /cart.js et recalcule le state */
  function refreshFromCart(){
    fetch('/cart.js', { cache: 'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var root = document.querySelector('[data-cart-bundle-tiers]');
        if (!root) return;
        var upsellVid = parseInt(root.dataset.upsellVariantId || '0', 10);
        var totalCents = cart.total_price || 0;
        var totalQty = 0;
        var cartImages = [];
        (cart.items || []).forEach(function(it){
          /* Exclut Garantie Sérénité (upsell) */
          if (upsellVid && it.variant_id === upsellVid) {
            totalCents -= it.final_line_price;
            return;
          }
          /* Exclut cadeaux (bundle builder gifts, produits à 0€) */
          if (it.properties && (it.properties._is_gift === 'true' || it.properties._bundle_gift === '1')) {
            totalCents -= it.final_line_price;
            return;
          }
          if (it.final_price === 0) return;
          totalQty += it.quantity;
          if (it.image) {
            for (var q = 0; q < it.quantity; q++) cartImages.push(it.image);
          }
        });
        update({ totalCents: totalCents, totalQty: totalQty, cartImages: cartImages });
      })
      .catch(function(){});
  }

  /* Init dès que le DOM est prêt (ou immédiatement si déjà prêt) */
  function bootstrap(){
    update(); /* Premier render avec les data-attrs Liquid */
    /* Après un tour d'event loop, on re-fetch au cas où /cart.js diffère (upsell auto-added etc.) */
    setTimeout(refreshFromCart, 200);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  /* Listen to cart updates (Dawn dispatches 'cartUpdated' — camelCase, sans deux-points) */
  document.addEventListener('cartUpdated', refreshFromCart);

  /* Observe le body pour détecter quand le cart drawer est re-render (Dawn fait innerHTML=)
     et que notre module réapparaît fraîchement injecté */
  var mo = new MutationObserver(function(mutations){
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches('[data-cart-bundle-tiers]')) ||
            (n.querySelector && n.querySelector('[data-cart-bundle-tiers]'))) {
          /* Re-render détecté → update immédiat, puis refetch pour être sûr du state */
          update();
          setTimeout(refreshFromCart, 100);
          return;
        }
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
